export class SafeMap<K, V> extends Map<K, V> {
    forEachKey(key: K, lambda: (v: V) => void) {
        const v = this.get(key);
        if (v) {
            lambda(v);
        }
    }
}
